import React from 'react'
import { Link, useHistory } from "react-router-dom"
import {
  Row,
  Col,
  Form,
  Input,
  Button,
  // Checkbox
} from 'antd'
import { UserOutlined, LockOutlined } from '@ant-design/icons'
import { useAuth } from '../../contexts/AuthContext'

const Login = () => {
  const { login } = useAuth()
  const history = useHistory()

  const onFinish = (values) => {
    login(values.email, values.password)
      .then(user => {
        history.push("/")
      })
    // console.log('Success:', values)
  }

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo)
  }

  return (
    <Row justify="center">
      <Col span={24} lg={{ span: 7 }}>
        <div className="form-container">
          <div className="form-header">
            <h1>Log In</h1>
            <p>Log In to your account</p>
          </div>
          <Form
            name="normal_login"
            className="login-form"
            // initialValues={{ remember: true }}
            size="large"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item
              name="email"
              rules={[
                {
                  required: true, message: 'E-mail is required!'
                },
                {
                  type: 'email', message: 'Please enter valid E-mail!',
                }
              ]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="Email" />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[{ required: true, message: 'Password is reuired!' }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                type="password"
                placeholder="Password"
              />
            </Form.Item>
            <Form.Item className="mt-2">
              <Button type="primary" htmlType="submit">
                Log in
              </Button>
              {/* <Form.Item name="remember" valuePropName="checked" noStyle>
                  <Checkbox>Remember me</Checkbox>
                </Form.Item> */}

              <Button type="link" className="form-link-right">
                <Link to="/auth/forgot">Forgot password?</Link>
              </Button>
            </Form.Item>

            <div className="text-center my-3">
              Create account? <Link to="/auth/signup">Sign Up</Link>
            </div>
          </Form>
        </div>
      </Col>
    </Row>
  )
}

export default Login
